// extracted by mini-css-extract-plugin
export default {"select-list":"RaLsz","select-list__list":"vP9Yb","select-list__item":"dSb0A"};